export class BuilderTemplates {
  public id: number;
  public classificationTags: string;
  public creationDate: Date;
  public demoUrl: string;
  public description: string;
  public pagesData: any;
  public published: any;
  public categories: any;
  public screenShotUrl: string;
  public desktopScreenShotUrl: string;
  public mobileScreenShotUrl: string;
  public slug: string;
  public thumbnail: string;
  public title: string;
  public type: string;
  public run_url: string;
  public ever_recreated: boolean;
}
